import React from "react";

export const hasExplanation = component => {
  return component !== undefined
    ? component.config.hasExplanation !== undefined
    : false;
};
export const checkAndGetExplanations = (
  component,
  explanations,
  indicators,
  lng
) => {
  let indicatorsExplanation = [];
  explanations &&
    component !== undefined &&
    // eslint-disable-next-line array-callback-return
    explanations.map((explanation, i) => {
      // eslint-disable-next-line array-callback-return
      component.indicators.map((indicator, j) => {
        if (explanation.target === indicator) {
          indicatorsExplanation.push(explanation);
        }
      });
    });
  let result = null;
  if (indicatorsExplanation.length > 0) {
    result = (
      // eslint-disable-next-line react/react-in-jsx-scope
      <div>
        {indicatorsExplanation.map((explanation, i) => {
          let indicatorName = getIndicatorLabel(explanation.target, indicators);
          return (
            <div
              style={{
                textAlign: "justify",
                textJustify: "inter-word"
              }}
            >
              {indicatorName} :
              {explanation.content[lng]
                ? explanation.content[lng]
                : explanation.content["fr"]
                  ? explanation.content["fr"]
                  : explanation.content["en"]
                    ? explanation.content["en"]
                    : explanation.content["nl"] && explanation.content["nl"]}
            </div>
          );
        })}
      </div>
    );
  }

  return result;
};
export const checkForComments = (component, comments, slideId) => {
  let hasComments = false;
  comments &&
    component !== undefined &&
    // eslint-disable-next-line array-callback-return
    comments.map((comment, i) => {
      if (
        comment.componentId === component.componentId &&
        comment.slideId === slideId
      ) {
        hasComments = true;
      }
    });
  return hasComments;
};

export const getIndicatorLabel = (indicator, indicatorsList) => {
  let result = "";
  indicatorsList &&
    // eslint-disable-next-line array-callback-return
    indicatorsList.map((indic, i) => {
      if (indic.code.slice(1) === indicator) {
        return (result = indic.label.fr);
      }
    });

  return result;
};

export const checkIfIndicatorHasExplanation = (indicator, explanations) => {
  let result = false;
  explanations &&
    // eslint-disable-next-line array-callback-return
    explanations.map((explanation, i) => {
      if (explanation.target === indicator) {
        result = true;
      }
    });

  return result;
};



// WEBPACK FOOTER //
// ./src/utils/presentaion.js